import {
  LitElement,
  html,
  unsafeSVG,
  property,
} from '@oskecare/fe-utilities/lib/LitElement/index.js';
import infoIcon from '@oskecare/orange-design-system/src/assets/icons/info.svg';
import errorSevereIcon from '@oskecare/orange-design-system/src/assets/icons/error-severe.svg';
import warningIcon from '@oskecare/orange-design-system/src/assets/icons/warning-important.svg';
import style from './style.scss';

export const TYPE_ERROR = 'error';
export const TYPE_INFO = 'info';
export const TYPE_WARNING = 'warning';

class Message extends LitElement {
  /**
   * Type specifies color and icon of the message component
   *
   * @type {('info'|'warning'|'error')}
   */
  @property({ type: String })
  accessor type = TYPE_INFO;

  /**
   * @type {?(string|TemplateString)}
   */
  @property({ attribute: false })
  accessor value = null;

  static get styles() {
    return [style];
  }

  /**
   * @returns {?TemplateResult}
   */
  get icon() {
    return (
      {
        [TYPE_ERROR]: unsafeSVG(errorSevereIcon),
        [TYPE_INFO]: unsafeSVG(infoIcon),
        [TYPE_WARNING]: unsafeSVG(warningIcon),
      }[this.type] ?? null
    );
  }

  /**
   * @returns {?string}
   */
  get iconClass() {
    return (
      {
        [TYPE_ERROR]: 'icon--danger',
        [TYPE_INFO]: 'icon--info',
        [TYPE_WARNING]: 'icon--warning',
      }[this.type] ?? null
    );
  }

  render() {
    if (!this.value) {
      return null;
    }

    return html`
      <p class="message ${this.type === TYPE_ERROR ? 'message--error' : null}">
        ${this.icon
          ? html`
              <svg class="icon icon--medium message__icon ${this.iconClass}" aria-hidden="true">
                ${this.icon}
              </svg>
            `
          : null}
        ${this.value}
      </p>
    `;
  }
}

if (!customElements.get('osk-message')) {
  customElements.define('osk-message', Message);
}

export default Message;
